/**
 * Affiche le message d'erreur renvoyé par le back (source de vérité).
 * Le front ne reformate pas le métier — il extrait seulement `message` de la réponse.
 */
function extractMessage(value: unknown): string | null {
  if (typeof value === "string" && value.trim()) {
    return value.trim();
  }

  if (Array.isArray(value) && value.length > 0) {
    return value
      .map((item) => (typeof item === "string" ? item : String(item)))
      .filter(Boolean)
      .join(" ");
  }

  if (value && typeof value === "object" && "message" in value) {
    return extractMessage((value as { message: unknown }).message);
  }

  return null;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  const err = error as {
    response?: { data?: { message?: unknown } };
    message?: string;
  };

  const fromBody = extractMessage(err?.response?.data?.message);
  if (fromBody) return fromBody;

  const fromRoot = extractMessage(err?.response?.data);
  if (fromRoot) return fromRoot;

  if (typeof err?.message === "string" && err.message.trim()) {
    return err.message.trim();
  }

  return fallback;
}
